export default __webpack_public_path__ + "static/media/MDX-BUSD.7041702b.png";